import type Piece from "~~/types/Piece";

import cliffside from "~/assets/images/art/cliffside.webp";
import untitled from "~/assets/images/art/untitled.webp";
import dandelions from "~/assets/images/art/dandelions.webp";
import itreallywas from "~/assets/images/art/itreallywas.webp";
import paris from "~/assets/images/art/paris.webp";
import wolf from "~/assets/images/art/wolf.webp";
import girlhood from "~/assets/images/art/girlhood.webp";
import petitcove from "~/assets/images/art/petitcove.webp";
import settled from "~/assets/images/art/settled.webp";
import weller from "~/assets/images/art/weller.webp";
import sanjuan from "~/assets/images/art/sanjuan.webp";
import forget from "~/assets/images/art/forget.webp";
import home from "~/assets/images/art/home.webp";
import blair from "~/assets/images/art/blair.webp";
import boxer from "~/assets/images/art/theboxer.webp";
import cosmo from "~/assets/images/art/cosmo.webp";
import dexter from "~/assets/images/art/dexter.webp";
import yoshimi from "~/assets/images/art/yoshimi.webp";
import secretgarden from "~/assets/images/art/secretgarden.webp";
import waterlilies from "~/assets/images/art/waterlilies.webp";
import mandy from "~/assets/images/art/mandy.webp";
import pinkCat from "~/assets/images/art/pink-cat.jpg";
import windFishEgg from "~/assets/images/art/wind-fish-egg.jpg";
import teapot from "~/assets/images/art/teapot.jpg";
import rabbit from "~/assets/images/art/rabbit.jpg";

const art: Array<Piece> = [
  {
    slug: "cat-4",
    thumb: "pink-catt.webp",
    frameColor: "bg-green",
    mainImage: pinkCat,
    title: "CAT 4",
    alt: "A ceramic cat lying on its back.",
    description: `A ceramic cat lying on its back.`,
    type: "sculpture",
  },
  {
    slug: "wind-fishs-egg",
    thumb: "wind-fish-eggt.webp",
    frameColor: "bg-pink",
    mainImage: windFishEgg,
    title: "Wind Fish's Egg",
    alt: "A ceramic egg on top of a mountain with a Wind Fish inside it",
    description: `A ceramic egg on top of a mountain with a Wind Fish inside it.`,
    type: "sculpture",
  },
  {
    slug: "teapot",
    thumb: "teapott.webp",
    frameColor: "bg-yellow",
    mainImage: teapot,
    title: "Teapot",
    alt: "A ceramic teapot with a textured floral design",
    description: `A ceramic teapot with a textured floral design.`,
    type: "sculpture",
  },
  {
    slug: "rabbit",
    thumb: "rabbitt.webp",
    frameColor: "bg-red",
    mainImage: rabbit,
    title: "Rabbit",
    alt: "A ceramic rabbit bust",
    description: `A ceramic rabbit bust.`,
    type: "sculpture",
  },
  {
    slug: "cliffside-seaside",
    thumb: "cliffsidet.jpg",
    frameColor: "bg-ice",
    mainImage: cliffside,
    title: "Cliffside, Seaside",
    alt: "A painting of the Amalfi Coast",
    description: ``,
    type: "painting",
  },
  {
    slug: "untitled",
    thumb: "untitledt.webp",
    frameColor: "bg-pink",
    mainImage: untitled,
    title: "(Untitled)",
    alt: "A mixed media painting of Breakfast at Tiffany's, featuring Barbie",
    description: `A mixed media painting of Breakfast at Tiffany's, featuring Barbie.`,
    type: "painting",
  },
  {
    slug: "dandelions",
    thumb: "dandelionst.jpg",
    frameColor: "bg-cerulean",
    mainImage: dandelions,
    title: "Dandelions",
    alt: "A painting of a cave surrounded by greenery and dandelions",
    description: `A painting of a cave surrounded by greenery and dandelions.`,
    type: "painting",
  },
  {
    slug: "it-really-was-wasnt-it",
    thumb: "itreallywast.jpg",
    frameColor: "bg-green",
    mainImage: itreallywas,
    title: "It Really Was, Wasn't it?",
    alt: "A painting of the bank of Jenny Lake at the Grand Tetons",
    description: `A painting of the bank of Jenny Lake at the Grand Tetons.`,
    type: "painting",
  },
  {
    slug: "4-nights-in-paris",
    thumb: "parist.jpg",
    frameColor: "bg-yellow",
    mainImage: paris,
    title: "4 Nights in Paris",
    alt: "A painting of a bridge over the Seine in Paris at night.",
    description: `A painting of a bridge over the Seine in Paris at night.`,
    type: "painting",
  },
  {
    slug: "wolf-country",
    thumb: "wolft.jpg",
    frameColor: "bg-red",
    mainImage: wolf,
    title: "Wolf Country",
    alt: "A painting of the Grand Tetons with flowers.",
    description: `A painting of the Grand Tetons with flowers.`,
    type: "painting",
  },
  {
    slug: "girlhood",
    thumb: "girlhoodt.jpg",
    frameColor: "bg-ice",
    mainImage: girlhood,
    title: "Girlhood",
    alt: "A painting of the artist's daughter on a tricycle in a green yard.",
    description: `A painting of the artist's daughter on a tricycle in a green yard.`,
    type: "painting",
  },
  {
    slug: "petit-cove",
    thumb: "petitcovet.jpg",
    frameColor: "bg-pink",
    mainImage: petitcove,
    title: "Petit Cove",
    alt: "A painting of a cove at Le Rocher et le Belvédère at Versailles. ",
    description: `A painting of a cove at Le Rocher et le Belvédère at Versailles.`,
    type: "painting",
  },
  {
    slug: "settled",
    thumb: "settledt.jpg",
    frameColor: "bg-green",
    mainImage: settled,
    title: "Settled",
    alt: "A painting of a mountain with a field of flowers",
    description: `A painting of a mountain with a field of flowers.`,
    type: "painting",
  },
  {
    slug: "old-well-er",
    thumb: "wellert.jpg",
    frameColor: "bg-yellow",
    mainImage: weller,
    title: "Old Well(er)",
    alt: "A painting of the Old Well at Chapel Hill in NC.",
    description: `A painting of the Old Well at Chapel Hill in NC.`,
    type: "painting",
  },
  {
    slug: "san-juan",
    thumb: "sanjuant.jpg",
    frameColor: "bg-ice",
    mainImage: sanjuan,
    title: "San Juan",
    alt: "A painting of the sea as seen from a Spanish Fort in San Juan",
    description: `A painting of the sea as seen from a Spanish Fort in San Juan.`,
    type: "painting",
  },
  {
    slug: "how-could-i-forget",
    thumb: "forgett.jpg",
    frameColor: "bg-cerulean",
    mainImage: forget,
    title: "How Could I Forget?",
    alt: "A painting of a field of poppies with a deteriorating roman statue.",
    description: `A painting of a field of poppies with a deteriorating roman statue.`,
    type: "painting",
  },
  {
    slug: "home",
    thumb: "homet.jpg",
    frameColor: "bg-red",
    mainImage: home,
    title: "Home",
    alt: "A painting of a brick house surrounded by trees.",
    description: `A painting of a brick house surrounded by trees.`,
    type: "painting",
  },
  {
    slug: "sunny-disposition",
    thumb: "blairt.jpg",
    frameColor: "bg-pink",
    mainImage: blair,
    title: "Sunny Disposition",
    alt: "A painting of the Blair Building in Decatur, GA.",
    description: `A painting of the Blair Building in Decatur, GA.`,
    type: "painting",
  },
  {
    slug: "the-boxer",
    thumb: "theboxert.jpg",
    frameColor: "bg-yellow",
    mainImage: boxer,
    title: "The Boxer",
    alt: "A painting of Cockburn Street in Edinburgh at night.",
    description: `A painting of Cockburn Street in Edinburgh at night.`,
    type: "painting",
  },
  {
    slug: "secret-garden",
    thumb: "secretgardent.jpg",
    frameColor: "bg-ice",
    mainImage: secretgarden,
    title: "Secret Garden",
    alt: "A painting of a garden with a gazebo and a willow.",
    description: `A painting of a garden with a gazebo and a willow.`,
    type: "painting",
  },
  {
    slug: "waterlilies",
    thumb: "waterliliest.jpg",
    frameColor: "bg-red",
    mainImage: waterlilies,
    title: "Waterlilies",
    alt: "A painting of waterlilies with wisteria - an homage to Monet.",
    description: `A painting of waterlilies with wisteria - an homage to Monet.`,
    type: "painting",
  },
  {
    slug: "cosmonaut",
    thumb: "cosmot.jpg",
    frameColor: "bg-yellow",
    mainImage: cosmo,
    title: "Cosmonaut",
    alt: "A painting of a black cat hiding in a plant.",
    description: `A painting of a black cat hiding in a plant.`,
    type: "painting",
  },
  {
    slug: "dexter",
    thumb: "dextert.jpg",
    frameColor: "bg-cerulean",
    mainImage: dexter,
    title: "Dexter",
    alt: "A painting of a green quaker parrot on an orange background.",
    description: `A painting of a green quaker parrot on an orange background.`,
    type: "painting",
  },
  {
    slug: "yoshimi",
    thumb: "yoshi.jpg",
    frameColor: "bg-green",
    mainImage: yoshimi,
    title: "Yoshimi",
    alt: "A painting of a galah named Yoshi.",
    description: `A painting of a galah named Yoshi.`,
    type: "painting",
  },
  {
    slug: "mandy",
    thumb: "mandyt.jpg",
    frameColor: "bg-pink",
    mainImage: mandy,
    title: "Mandy",
    alt: "A painting of a dog named Mandy.",
    description: `A painting of a dog named Mandy.`,
    type: "painting",
  },
];

export default art;
